module.exports = __webpack_public_path__ + "static/media/supply-cross.c0b2d564.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/supply-cross.svg
// module id = 1047
// module chunks = 0